var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Config } from '../../api/config';
import { precheckDynamicCheckListFormUrl } from '../../api/url';
import { MuiStack } from '../../components';
import CustomeAccordianWithButton from '../../components/atoms/customAccordianWithButton';
import SkeletonLoader from '../../components/atoms/sketeton';
import { NoRowsOverlay } from '../../components/molecules/dataGridComponent';
import { APISchema, EFIChecklistKeys, EFIChecklistParent, EFIJobCardDetailKeys, EFinalInspectorModuleSection, ESectionAttributeValue, LOCAL_STORAGE_KEYS, Module, isModuleConfig } from '../../constants';
import { setUpdatedModuleSectionByChannel, showLoader } from '../../redux/commonSlice';
import { getByIdAPI, getListAPI, setState } from '../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { systemColor } from '../../theme/systemColor';
import { getLocalStorageItem } from '../../utils/storageHelper';
import FinalInspectorAdditionalJobs from './finalInspectorTaskDetails/finalInspector.additionalJobs';
import FinalInspectorCustomerComplaint from './finalInspectorTaskDetails/finalInspector.customerComplaint';
import FinalInspectorDynamicChecklist from './finalInspectorTaskDetails/finalInspector.dynamicChecklist';
var InitialFIChecklistItemChange = {
    customerComplaints: {
        isItemRejected: false,
        isSaveClick: false
    },
    periodicMaintanance: {
        isItemRejected: false,
        isSaveClick: false
    },
    standardJobs: {
        isItemRejected: false,
        isSaveClick: false
    },
    additionalJobs: {
        isItemRejected: false,
        isSaveClick: false
    },
    staticFIChecklist: {
        isItemRejected: false,
        isSaveClick: false
    },
    dynamicFIChecklist: {
        isItemRejected: false,
        isSaveClick: false
    },
    fastnerCheklist: {
        isItemRejected: false,
        isSaveClick: false
    },
    roadTest: {
        isItemRejected: false,
        isSaveClick: false
    }
};
var JobCardReworkTab = function () {
    var id = useParams().id;
    var dispatch = useAppDispatch();
    var updatedModuleSectionByChannel = useSelector(function (state) { return state.common; }).updatedModuleSectionByChannel;
    var _a = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _a.documentDetailsGetById, FinalInspectionChecklistCount = _a.FinalInspectionChecklistCount, callReworkTabAPIS = _a.callReworkTabAPIS;
    var skeletonArray = Array.from({
        length: 4
    });
    var _b = useState(false), allswitchEnabled = _b[0], setAllSwitchEnabled = _b[1];
    var _c = useState(true), standardJobApiCall = _c[0], setStandardJobApiCall = _c[1];
    var _d = useState(true), addiotionalJobApiCall = _d[0], setAddiotionalJobApiCall = _d[1];
    var _e = useState(true), dynamicChecklistApiCall = _e[0], setDynamicChecklistApiCall = _e[1];
    var _f = useState(true), staticFIChecklistApiCall = _f[0], setStaticFIChecklistApiCall = _f[1];
    var _g = useState(true), fastnerChecklistApiCall = _g[0], setFastnerChecklistApiCall = _g[1];
    var _h = useState(true), periodicMaintainanceApiCall = _h[0], setPeriodicMaintainanceApiCall = _h[1];
    var _j = useState(true), customerComplaintApiCall = _j[0], setCustomerComplaintApiCall = _j[1];
    var _k = useState([]), staticFIChecklist = _k[0], setStaticFIChecklist = _k[1];
    var _l = useState([]), dynamicFIChecklist = _l[0], setDynamicFIChecklist = _l[1];
    var _m = useState([]), fastenerChecklist = _m[0], setFastenerChecklist = _m[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _o = useState(false), isLoading = _o[0], setIsLoading = _o[1];
    var isViewOnly = true;
    useEffect(function () {
        var _documentDetailsGetBy;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy = documentDetailsGetById.data) !== null && _documentDetailsGetBy !== void 0 && _documentDetailsGetBy.ProductId) {
            var _documentDetailsGetBy2;
            if (callReworkTabAPIS !== (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.id)) {
                var _documentDetailsGetBy3;
                getInitialData(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy3 = documentDetailsGetById.data) === null || _documentDetailsGetBy3 === void 0 ? void 0 : _documentDetailsGetBy3.ProductId);
            }
        }
    }, []);
    var getJCDetailFIResponse = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, answersResponse, _answersResponse$payl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetailFinalInspectionResponse/JobCardDetailFIResponse"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && Array.isArray(answersResponse.payload.data)) {
                        return [2 /*return*/, answersResponse !== null && answersResponse !== void 0 && (_answersResponse$payl = answersResponse.payload) !== null && _answersResponse$payl !== void 0 && _answersResponse$payl.data ? answersResponse.payload.data : []];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedAdditionalJobsList = function (allSaved) { return __awaiter(void 0, void 0, void 0, function () {
        var _additionalJobResult$, body, additionalJobResult, _additionalJobResult$2, _additionalJobResult$3, masterList, savedAdditional_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id,
                        Key: EFIJobCardDetailKeys.ADDITIONAL_JOBS
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetail/ByKey"),
                            request: body
                        }))];
                case 1:
                    additionalJobResult = _a.sent();
                    if (additionalJobResult.payload.success && (_additionalJobResult$ = additionalJobResult.payload.data) !== null && _additionalJobResult$ !== void 0 && _additionalJobResult$.Jobs) {
                        masterList = (_additionalJobResult$2 = additionalJobResult.payload.data) !== null && _additionalJobResult$2 !== void 0 && _additionalJobResult$2.Jobs ? (_additionalJobResult$3 = additionalJobResult.payload.data) === null || _additionalJobResult$3 === void 0 ? void 0 : _additionalJobResult$3.Jobs : {};
                        savedAdditional_1 = [];
                        masterList.map(function (masterItem) {
                            var matchedItem = allSaved.find(function (savedItem) { return savedItem.JobCardDetailId === masterItem.JobCardDetailId; });
                            if (matchedItem) {
                                savedAdditional_1.push(matchedItem);
                            }
                        });
                        return [2 /*return*/, savedAdditional_1];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedPmParts = function (allSaved) { return __awaiter(void 0, void 0, void 0, function () {
        var _answersResponse$payl2, body, answersResponse, _answersResponse$payl3, _answersResponse$payl4, masterList, savedPm_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id,
                        Key: EFIJobCardDetailKeys.PERIODIC_MAINTENANCE
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetail/ByKey"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && (_answersResponse$payl2 = answersResponse.payload.data) !== null && _answersResponse$payl2 !== void 0 && _answersResponse$payl2.Jobs) {
                        masterList = (_answersResponse$payl3 = answersResponse.payload.data) !== null && _answersResponse$payl3 !== void 0 && _answersResponse$payl3.Jobs ? (_answersResponse$payl4 = answersResponse.payload.data) === null || _answersResponse$payl4 === void 0 ? void 0 : _answersResponse$payl4.Jobs : {};
                        savedPm_1 = [];
                        masterList.map(function (masterItem) {
                            var matchedItem = allSaved.find(function (savedItem) { return savedItem.JobCardDetailId === masterItem.JobCardDetailId; });
                            if (matchedItem) {
                                savedPm_1.push(matchedItem);
                            }
                        });
                        return [2 /*return*/, savedPm_1];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedStandardJobs = function (allSaved) { return __awaiter(void 0, void 0, void 0, function () {
        var _answersResponse$payl5, body, answersResponse, _answersResponse$payl6, _answersResponse$payl7, masterList, savedStandard_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id,
                        Key: EFIJobCardDetailKeys.STANDARD_JOBS
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCardDetail/ByKey"),
                            request: body
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success && (_answersResponse$payl5 = answersResponse.payload.data) !== null && _answersResponse$payl5 !== void 0 && _answersResponse$payl5.Jobs) {
                        masterList = (_answersResponse$payl6 = answersResponse.payload.data) !== null && _answersResponse$payl6 !== void 0 && _answersResponse$payl6.Jobs ? (_answersResponse$payl7 = answersResponse.payload.data) === null || _answersResponse$payl7 === void 0 ? void 0 : _answersResponse$payl7.Jobs : {};
                        savedStandard_1 = [];
                        masterList.map(function (masterItem) {
                            var matchedItem = allSaved.find(function (savedItem) { return savedItem.JobCardDetailId === masterItem.JobCardDetailId; });
                            if (matchedItem) {
                                savedStandard_1.push(matchedItem);
                            }
                        });
                        return [2 /*return*/, savedStandard_1];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedComplaints = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, savedRejectedComplaintResponse, _savedRejectedComplai, _savedRejectedComplai2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobItemFinalInspectionResponse/JobItemFIResponse"),
                            request: body
                        }))];
                case 1:
                    savedRejectedComplaintResponse = _a.sent();
                    if (savedRejectedComplaintResponse.payload.success && savedRejectedComplaintResponse.payload.data) {
                        return [2 /*return*/, savedRejectedComplaintResponse !== null && savedRejectedComplaintResponse !== void 0 && (_savedRejectedComplai = savedRejectedComplaintResponse.payload) !== null && _savedRejectedComplai !== void 0 && _savedRejectedComplai.data ? savedRejectedComplaintResponse === null || savedRejectedComplaintResponse === void 0 || (_savedRejectedComplai2 = savedRejectedComplaintResponse.payload) === null || _savedRejectedComplai2 === void 0 ? void 0 : _savedRejectedComplai2.data : []];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedDynamicChecklist = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var body, allCheckListSavedData, returnData, _dynamicChecklistMast, _dynamicChecklistMast2, _fastnercChecklistMas, _fastnercChecklistMas2, _StaticChecklistMaste, _StaticChecklistMaste2, _allCheckListSavedDat, _allCheckListSavedDat2, DynamicRequestBody, dynamicChecklistMaster_1, FastnerRequestBody, fastnercChecklistMaster_1, StaticRequestBody, StaticChecklistMaster_1, dynamicSaved_1, fastenerSaved_1, staticSaved_1, allDynamic_1, allFastner_1, allStatic_1, _dynamicChecklistMast3, AllQuestions, _fastnercChecklistMas3, AllQuestions, _StaticChecklistMaste3, AllQuestions, _allCheckListSavedDat3, dynamicApprovedCount, dynamicRejectedCount, dynamicTotalCount, fastnerApprovedCount, fastnerRejectedCount, fastnerTotalCount, staticApprovedCount, staticRejectedCount, staticTotalCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "FinalInspectionCheckList/FICheckList"),
                            request: body
                        }))];
                case 1:
                    allCheckListSavedData = _a.sent();
                    returnData = {
                        dynamicApprovedCount: 0,
                        dynamicRejectedCount: 0,
                        dynamicTotalCount: 0,
                        fastnerApprovedCount: 0,
                        fastnerRejectedCount: 0,
                        fastnerTotalCount: 0,
                        staticApprovedCount: 0,
                        staticRejectedCount: 0,
                        staticTotalCount: 0
                    };
                    if (!(allCheckListSavedData.payload.success && allCheckListSavedData.payload.data && allCheckListSavedData.payload.data.Options)) return [3 /*break*/, 5];
                    DynamicRequestBody = {
                        "SystemName": EFIChecklistKeys.DynamicChecklist,
                        "ChildId": productId,
                        "ProductId": productId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: DynamicRequestBody
                        }))];
                case 2:
                    dynamicChecklistMaster_1 = _a.sent();
                    FastnerRequestBody = {
                        "SystemName": EFIChecklistKeys.FastnerChecklist,
                        "ChildId": productId,
                        "ProductId": productId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: FastnerRequestBody
                        }))];
                case 3:
                    fastnercChecklistMaster_1 = _a.sent();
                    StaticRequestBody = {
                        "SystemName": EFIChecklistKeys.StaticChecklist,
                        "ChildId": productId,
                        "ProductId": productId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: StaticRequestBody
                        }))];
                case 4:
                    StaticChecklistMaster_1 = _a.sent();
                    dynamicSaved_1 = [];
                    fastenerSaved_1 = [];
                    staticSaved_1 = [];
                    allDynamic_1 = [];
                    allFastner_1 = [];
                    allStatic_1 = [];
                    if ((_dynamicChecklistMast = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast !== void 0 && _dynamicChecklistMast.success && (_dynamicChecklistMast2 = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast2 !== void 0 && _dynamicChecklistMast2.data) {
                        AllQuestions = (_dynamicChecklistMast3 = dynamicChecklistMaster_1.payload.value) === null || _dynamicChecklistMast3 === void 0 ? void 0 : _dynamicChecklistMast3.data.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
                        allDynamic_1 = AllQuestions;
                    }
                    if ((_fastnercChecklistMas = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas !== void 0 && _fastnercChecklistMas.success && (_fastnercChecklistMas2 = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas2 !== void 0 && _fastnercChecklistMas2.data) {
                        AllQuestions = (_fastnercChecklistMas3 = fastnercChecklistMaster_1.payload.value) === null || _fastnercChecklistMas3 === void 0 ? void 0 : _fastnercChecklistMas3.data.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
                        allFastner_1 = AllQuestions;
                    }
                    if ((_StaticChecklistMaste = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste !== void 0 && _StaticChecklistMaste.success && (_StaticChecklistMaste2 = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste2 !== void 0 && _StaticChecklistMaste2.data) {
                        AllQuestions = (_StaticChecklistMaste3 = StaticChecklistMaster_1.payload.value) === null || _StaticChecklistMaste3 === void 0 ? void 0 : _StaticChecklistMaste3.data.flatMap(function (obj) { return obj.Questions ? obj.Questions : []; });
                        allStatic_1 = AllQuestions;
                    }
                    if (allCheckListSavedData !== null && allCheckListSavedData !== void 0 && (_allCheckListSavedDat = allCheckListSavedData.payload) !== null && _allCheckListSavedDat !== void 0 && (_allCheckListSavedDat = _allCheckListSavedDat.data) !== null && _allCheckListSavedDat !== void 0 && _allCheckListSavedDat.Options && (allCheckListSavedData === null || allCheckListSavedData === void 0 || (_allCheckListSavedDat2 = allCheckListSavedData.payload) === null || _allCheckListSavedDat2 === void 0 || (_allCheckListSavedDat2 = _allCheckListSavedDat2.data) === null || _allCheckListSavedDat2 === void 0 || (_allCheckListSavedDat2 = _allCheckListSavedDat2.Options) === null || _allCheckListSavedDat2 === void 0 ? void 0 : _allCheckListSavedDat2.length) > 0) {
                        (_allCheckListSavedDat3 = allCheckListSavedData.payload.data.Options) === null || _allCheckListSavedDat3 === void 0 || _allCheckListSavedDat3.map(function (savedItem) {
                            var _dynamicChecklistMast4, _dynamicChecklistMast5, _fastnercChecklistMas4, _fastnercChecklistMas5, _StaticChecklistMaste4, _StaticChecklistMaste5;
                            if ((_dynamicChecklistMast4 = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast4 !== void 0 && _dynamicChecklistMast4.success && (_dynamicChecklistMast5 = dynamicChecklistMaster_1.payload.value) !== null && _dynamicChecklistMast5 !== void 0 && _dynamicChecklistMast5.data) {
                                var matchItem = allDynamic_1.find(function (item) { return item.QuestionId === savedItem.QuestionId; });
                                if (matchItem) {
                                    dynamicSaved_1.push(savedItem);
                                }
                            }
                            if ((_fastnercChecklistMas4 = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas4 !== void 0 && _fastnercChecklistMas4.success && (_fastnercChecklistMas5 = fastnercChecklistMaster_1.payload.value) !== null && _fastnercChecklistMas5 !== void 0 && _fastnercChecklistMas5.data) {
                                var matchItem = allFastner_1.find(function (item) { return item.QuestionId === savedItem.QuestionId; });
                                if (matchItem) {
                                    fastenerSaved_1.push(savedItem);
                                }
                            }
                            if ((_StaticChecklistMaste4 = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste4 !== void 0 && _StaticChecklistMaste4.success && (_StaticChecklistMaste5 = StaticChecklistMaster_1.payload.value) !== null && _StaticChecklistMaste5 !== void 0 && _StaticChecklistMaste5.data) {
                                var matchItem = allStatic_1.find(function (item) { return item.QuestionId === savedItem.QuestionId; });
                                if (matchItem) {
                                    staticSaved_1.push(savedItem);
                                }
                            }
                        });
                    }
                    dynamicApprovedCount = dynamicSaved_1.filter(function (item) { return item.ResponseValue === "true"; }).length;
                    dynamicRejectedCount = dynamicSaved_1.filter(function (item) { return item.ResponseValue === "false"; }).length;
                    dynamicTotalCount = allDynamic_1.length;
                    fastnerApprovedCount = fastenerSaved_1.filter(function (item) { return item.ResponseValue === "true"; }).length;
                    fastnerRejectedCount = fastenerSaved_1.filter(function (item) { return item.ResponseValue === "false"; }).length;
                    fastnerTotalCount = allFastner_1.length;
                    staticApprovedCount = staticSaved_1.filter(function (item) { return item.ResponseValue === "true"; }).length;
                    staticRejectedCount = staticSaved_1.filter(function (item) { return item.ResponseValue === "false"; }).length;
                    staticTotalCount = allStatic_1.length;
                    returnData = {
                        dynamicApprovedCount: dynamicApprovedCount,
                        dynamicRejectedCount: dynamicRejectedCount,
                        dynamicTotalCount: dynamicTotalCount,
                        fastnerApprovedCount: fastnerApprovedCount,
                        fastnerRejectedCount: fastnerRejectedCount,
                        fastnerTotalCount: fastnerTotalCount,
                        staticApprovedCount: staticApprovedCount,
                        staticRejectedCount: staticRejectedCount,
                        staticTotalCount: staticTotalCount
                    };
                    return [3 /*break*/, 6];
                case 5:
                    returnData = {
                        dynamicApprovedCount: 0,
                        dynamicRejectedCount: 0,
                        dynamicTotalCount: 0,
                        fastnerApprovedCount: 0,
                        fastnerRejectedCount: 0,
                        fastnerTotalCount: 0,
                        staticApprovedCount: 0,
                        staticRejectedCount: 0,
                        staticTotalCount: 0
                    };
                    _a.label = 6;
                case 6: return [2 /*return*/, returnData];
            }
        });
    }); };
    var getRoadTest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        JobCardId: id !== null && id !== void 0 ? id : ""
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL + APISchema.Jobcard, "/RoadTest"),
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (response.payload.success && response.payload.data && response.payload.data.RoadTest && response.payload.data.RoadTest.length > 0) {
                        return [2 /*return*/, {
                                roadTestApprovedCount: 1,
                                roadTestRejectedCount: 0
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                roadTestApprovedCount: 0,
                                roadTestRejectedCount: 0
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getMasterTotalCount = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, body, response, _response$payload2, _response$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        JobCardId: id,
                        ProductId: productId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: "".concat(Config.baseURL, "JobCard/FIMasterCount?JobCardId=").concat(id),
                            request: body
                        }))];
                case 1:
                    response = _a.sent();
                    if ((_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success) {
                        return [2 /*return*/, response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && (_response$payload2 = _response$payload2.value) !== null && _response$payload2 !== void 0 && _response$payload2.data ? (_response$payload3 = response.payload) === null || _response$payload3 === void 0 || (_response$payload3 = _response$payload3.value) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.data : null];
                    }
                    else {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getAllChecklistSavedData = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var masterTotalCountResponse, JCDetailsMasterResponse, savedAdditionalJobs, totalAdditionalJobsCount, additionalJobsApprovedCount, additionalJobsRejectedCount, savedPmParts, totalPmPartsLength, pmPartsApprovedCount, pmPartsRejectedCount, savedStandardJobs, standardJobsTotalCount, StandardJobsApprovedCount, StandardJobsRejectedCount, savedCustomerComplaints, totalCustomerComplaintsLength, customerComplaintsApprovedCount, customerComplainteRejectCount, savedChecklistData, dynamicApprovedCount, dynamicRejectedCount, dynamicTotalCount, fastnerApprovedCount, fastnerRejectedCount, fastnerTotalCount, staticApprovedCount, staticRejectedCount, staticTotalCount, roadTestDetails, roadTestApprovedCount, allItemsSave, AllChecklistCount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(setState({
                        key: "FIChecklistItemChange",
                        value: InitialFIChecklistItemChange
                    }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getMasterTotalCount(productId)];
                case 2:
                    masterTotalCountResponse = _a.sent();
                    return [4 /*yield*/, getJCDetailFIResponse()];
                case 3:
                    JCDetailsMasterResponse = _a.sent();
                    return [4 /*yield*/, getSavedAdditionalJobsList(JCDetailsMasterResponse)];
                case 4:
                    savedAdditionalJobs = _a.sent();
                    totalAdditionalJobsCount = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.ADDITIONAL_JOBS ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.ADDITIONAL_JOBS : 0;
                    additionalJobsApprovedCount = savedAdditionalJobs.filter(function (item) { return item.Value === "true"; }).length;
                    additionalJobsRejectedCount = savedAdditionalJobs.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedPmParts(JCDetailsMasterResponse)];
                case 5:
                    savedPmParts = _a.sent();
                    totalPmPartsLength = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.PERIODIC_MAINTENANCE ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.PERIODIC_MAINTENANCE : 0;
                    pmPartsApprovedCount = savedPmParts.filter(function (item) { return item.Value === "true"; }).length;
                    pmPartsRejectedCount = savedPmParts.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedStandardJobs(JCDetailsMasterResponse)];
                case 6:
                    savedStandardJobs = _a.sent();
                    standardJobsTotalCount = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.STANDARD_JOBS ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.STANDARD_JOBS : 0;
                    StandardJobsApprovedCount = savedStandardJobs.filter(function (item) { return item.Value === "true"; }).length;
                    StandardJobsRejectedCount = savedStandardJobs.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedComplaints()];
                case 7:
                    savedCustomerComplaints = _a.sent();
                    totalCustomerComplaintsLength = masterTotalCountResponse !== null && masterTotalCountResponse !== void 0 && masterTotalCountResponse.CustomerVoiceToJobItem ? masterTotalCountResponse === null || masterTotalCountResponse === void 0 ? void 0 : masterTotalCountResponse.CustomerVoiceToJobItem : 0;
                    customerComplaintsApprovedCount = savedCustomerComplaints.filter(function (item) { return item.Value === "true"; }).length;
                    customerComplainteRejectCount = savedCustomerComplaints.filter(function (item) { return item.Value === "false"; }).length;
                    return [4 /*yield*/, getSavedDynamicChecklist(productId)];
                case 8:
                    savedChecklistData = _a.sent();
                    dynamicApprovedCount = savedChecklistData.dynamicApprovedCount;
                    dynamicRejectedCount = savedChecklistData.dynamicRejectedCount;
                    dynamicTotalCount = savedChecklistData.dynamicTotalCount;
                    fastnerApprovedCount = savedChecklistData.fastnerApprovedCount;
                    fastnerRejectedCount = savedChecklistData.fastnerRejectedCount;
                    fastnerTotalCount = savedChecklistData.fastnerTotalCount;
                    staticApprovedCount = savedChecklistData.staticApprovedCount;
                    staticRejectedCount = savedChecklistData.staticRejectedCount;
                    staticTotalCount = savedChecklistData.staticTotalCount;
                    return [4 /*yield*/, getRoadTest()];
                case 9:
                    roadTestDetails = _a.sent();
                    roadTestApprovedCount = roadTestDetails.roadTestApprovedCount;
                    allItemsSave = {
                        customerComplaints: {
                            isItemRejected: false,
                            isSaveClick: customerComplainteRejectCount > 0 || customerComplaintsApprovedCount > 0 || savedCustomerComplaints.length === 0 ? true : false
                        },
                        periodicMaintanance: {
                            isItemRejected: false,
                            isSaveClick: pmPartsRejectedCount > 0 || pmPartsApprovedCount > 0 || savedAdditionalJobs.length === 0 ? true : false
                        },
                        standardJobs: {
                            isItemRejected: false,
                            isSaveClick: StandardJobsRejectedCount > 0 || StandardJobsApprovedCount > 0 || savedStandardJobs.length === 0 ? true : false
                        },
                        additionalJobs: {
                            isItemRejected: false,
                            isSaveClick: additionalJobsRejectedCount > 0 || additionalJobsApprovedCount > 0 || savedAdditionalJobs.length === 0 ? true : false
                        },
                        staticFIChecklist: {
                            isItemRejected: false,
                            isSaveClick: staticRejectedCount > 0 || staticApprovedCount > 0 || staticTotalCount == 0 ? true : false
                        },
                        dynamicFIChecklist: {
                            isItemRejected: false,
                            isSaveClick: dynamicRejectedCount > 0 || dynamicApprovedCount > 0 || dynamicTotalCount == 0 ? true : false
                        },
                        fastnerCheklist: {
                            isItemRejected: false,
                            isSaveClick: fastnerRejectedCount > 0 || fastnerApprovedCount > 0 || fastnerTotalCount == 0 ? true : false
                        },
                        roadTest: {
                            isItemRejected: false,
                            isSaveClick: roadTestApprovedCount > 0 ? true : false
                        }
                    };
                    AllChecklistCount = {
                        customerComplaints: {
                            approvedCount: customerComplaintsApprovedCount,
                            totalCount: totalCustomerComplaintsLength,
                            rejectedCount: customerComplainteRejectCount
                        },
                        periodicMaintanance: {
                            approvedCount: pmPartsApprovedCount,
                            totalCount: totalPmPartsLength,
                            rejectedCount: pmPartsRejectedCount
                        },
                        standardJobs: {
                            approvedCount: StandardJobsApprovedCount,
                            totalCount: standardJobsTotalCount,
                            rejectedCount: StandardJobsRejectedCount
                        },
                        additionalJobs: {
                            approvedCount: additionalJobsApprovedCount,
                            totalCount: totalAdditionalJobsCount,
                            rejectedCount: additionalJobsRejectedCount
                        },
                        staticFIChecklist: {
                            approvedCount: staticApprovedCount,
                            totalCount: staticTotalCount,
                            rejectedCount: staticRejectedCount
                        },
                        dynamicFIChecklist: {
                            approvedCount: dynamicApprovedCount,
                            totalCount: dynamicTotalCount,
                            rejectedCount: dynamicRejectedCount
                        },
                        fastnerCheklist: {
                            approvedCount: fastnerApprovedCount,
                            totalCount: fastnerTotalCount,
                            rejectedCount: fastnerRejectedCount
                        },
                        roadTest: {
                            approvedCount: roadTestApprovedCount,
                            totalCount: 0,
                            rejectedCount: 0
                        }
                    };
                    return [4 /*yield*/, dispatch(setState({
                            key: "FinalInspectionChecklistCount",
                            value: AllChecklistCount
                        }))];
                case 10:
                    _a.sent();
                    return [4 /*yield*/, dispatch(setState({
                            key: "FIChecklistItemChange",
                            value: allItemsSave
                        }))];
                case 11:
                    _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 12:
                    _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var getInitialData = function (productId) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetailsGetBy4, data, updatedList_1, obj_1, newArray_1, finalModuleSectionArray_1, res, sortedArray;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setState({
                        key: "callReworkTabAPIS",
                        value: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.id
                    }));
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    setIsLoading(true);
                    data = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_FINALINSPECTION);
                    if (!((data === null || data === void 0 ? void 0 : data.length) > 0)) return [3 /*break*/, 3];
                    updatedList_1 = [];
                    data.map(function (item) {
                        var newObj = Object.assign({}, item, item.Section);
                        delete newObj.Section;
                        updatedList_1.push(_objectSpread(_objectSpread({}, newObj), {}, {
                            isAccordianOpen: true
                        }));
                    });
                    obj_1 = {};
                    newArray_1 = [];
                    finalModuleSectionArray_1 = [];
                    res = updatedList_1.map(function (elem) {
                        var newSectionAttribute = elem.SectionAttributes;
                        var mergedObj = null;
                        var newAttribute = newSectionAttribute.map(function (el) {
                            if (el !== null && el !== void 0 && el.Key && !el.IsDeleted) {
                                obj_1[el.Key] = el.Value === ESectionAttributeValue.ON ? true : false;
                                obj_1[el.Key + "DefaultValue"] = el.DefaultValue === ESectionAttributeValue.ON ? true : false;
                                mergedObj = _objectSpread(_objectSpread({}, el), obj_1);
                            }
                        });
                        if (mergedObj) {
                            newArray_1.push(mergedObj);
                        }
                        obj_1 = {};
                        delete elem.SectionAttributes;
                        elem['SectionAttributes'] = [];
                        newArray_1.forEach(function (value) {
                            newSectionAttribute.forEach(function (value1) {
                                if (value.id == value1.id) {
                                    elem.SectionAttributes.push(value);
                                }
                            });
                        });
                        finalModuleSectionArray_1.push(elem);
                    });
                    sortedArray = finalModuleSectionArray_1 === null || finalModuleSectionArray_1 === void 0 ? void 0 : finalModuleSectionArray_1.sort(function (a, b) { return a.Sequence - b.Sequence; });
                    return [4 /*yield*/, dispatch(setUpdatedModuleSectionByChannel(sortedArray))];
                case 2:
                    _a.sent();
                    getAllChecklistSavedData(productId);
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getAdditionalJobApiCall = function () {
        setAddiotionalJobApiCall(true);
    };
    var handleAccordianClick = function (value, key) {
        var _updatedModuleSection, _updatedList$find;
        console.log("handleAccordianClick - Before update:", {
            key: key,
            value: value,
            currentState: updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 || (_updatedModuleSection = updatedModuleSectionByChannel.find(function (item) { return item.Key === key; })) === null || _updatedModuleSection === void 0 ? void 0 : _updatedModuleSection.isAccordianOpen
        });
        var updatedList = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item) {
            if (item.Key === key) {
                console.log("Updating isAccordianOpen for ".concat(key, " from ").concat(item.isAccordianOpen, " to ").concat(value));
                return _objectSpread(_objectSpread({}, item), {}, {
                    isAccordianOpen: value
                });
            }
            return _objectSpread({}, item);
        });
        console.log("handleAccordianClick - After update:", {
            key: key,
            newValue: updatedList === null || updatedList === void 0 || (_updatedList$find = updatedList.find(function (item) { return item.Key === key; })) === null || _updatedList$find === void 0 ? void 0 : _updatedList$find.isAccordianOpen
        });
        dispatch(setUpdatedModuleSectionByChannel(updatedList));
    };
    useEffect(function () {
        console.log('updatedModuleSectionByChannel changed:', updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.find(function (item) { return item.Key === EFinalInspectorModuleSection.StaticFIChecklist; }));
        console.log('updatedModuleSectionByChannel changed:', updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.find(function (item) { return item.Key === EFinalInspectorModuleSection.CustomerComplaints; }));
    }, [updatedModuleSectionByChannel]);
    // console.log(`updatedModuleSectionByChannel`, updatedModuleSectionByChannel);
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 8,
        md: 8,
        sm: 12,
        xs: 12
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data && !isLoading ? /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        paddingBottom: IS_DESKTOP ? 12 : 0
    }, updatedModuleSectionByChannel && updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.length > 0 ? updatedModuleSectionByChannel.map(function (item) { return (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.CustomerComplaints && FinalInspectionChecklistCount.customerComplaints.rejectedCount > 0 ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 0px 8px 0px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            handleClick: function () { return setCustomerComplaintApiCall(true); },
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.CustomerComplaints); },
            declinejobCountVisible: FinalInspectionChecklistCount.customerComplaints.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.customerComplaints.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.customerComplaints.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.customerComplaints.approvedCount > 0 && FinalInspectionChecklistCount.customerComplaints.rejectedCount === 0,
            countVisible: false,
            listLength: FinalInspectionChecklistCount.customerComplaints.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorCustomerComplaint, {
            callApIStatus: customerComplaintApiCall,
            isViewOnly: isViewOnly,
            jobCardId: id || "",
            showOnlyRejectedItems: true
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.PeriodicMaintenance && FinalInspectionChecklistCount.periodicMaintanance.rejectedCount > 0 ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 0px 8px 0px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setPeriodicMaintainanceApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.PeriodicMaintenance); },
            declinejobCountVisible: FinalInspectionChecklistCount.periodicMaintanance.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.periodicMaintanance.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.periodicMaintanance.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.periodicMaintanance.approvedCount > 0 && FinalInspectionChecklistCount.periodicMaintanance.rejectedCount === 0,
            countVisible: false,
            listLength: FinalInspectionChecklistCount.periodicMaintanance.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorAdditionalJobs, {
            isViewOnly: isViewOnly,
            paramKey: EFIJobCardDetailKeys.PERIODIC_MAINTENANCE,
            callApIStatus: periodicMaintainanceApiCall,
            parentComponent: EFIChecklistParent.PeriodicMaintenance,
            jobCardId: id || "",
            showOnlyRejectedItems: true
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.StandardJobs && FinalInspectionChecklistCount.standardJobs.rejectedCount > 0 ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 0px 8px 0px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setStandardJobApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.StandardJobs); },
            declinejobCountVisible: FinalInspectionChecklistCount.standardJobs.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.standardJobs.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.standardJobs.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.standardJobs.approvedCount > 0 && FinalInspectionChecklistCount.standardJobs.rejectedCount === 0,
            countVisible: false,
            listLength: FinalInspectionChecklistCount.standardJobs.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorAdditionalJobs, {
            isViewOnly: isViewOnly,
            paramKey: EFIJobCardDetailKeys.STANDARD_JOBS,
            callApIStatus: standardJobApiCall,
            parentComponent: EFIChecklistParent.StandaredJobs,
            jobCardId: id || "",
            showOnlyRejectedItems: true
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.AdditionalJobs && FinalInspectionChecklistCount.additionalJobs.rejectedCount > 0 ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 0px 8px 0px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return getAdditionalJobApiCall(); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.AdditionalJobs); },
            declinejobCountVisible: FinalInspectionChecklistCount.additionalJobs.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.additionalJobs.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.additionalJobs.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.additionalJobs.approvedCount > 0 && FinalInspectionChecklistCount.additionalJobs.rejectedCount === 0,
            countVisible: false,
            listLength: FinalInspectionChecklistCount.additionalJobs.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorAdditionalJobs, {
            isViewOnly: isViewOnly,
            paramKey: EFIJobCardDetailKeys.ADDITIONAL_JOBS,
            callApIStatus: addiotionalJobApiCall,
            parentComponent: EFIChecklistParent.AdditionalJobs,
            jobCardId: id || "",
            showOnlyRejectedItems: true
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.StaticFIChecklist && FinalInspectionChecklistCount.staticFIChecklist.rejectedCount > 0 ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 0px 8px 0px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setStaticFIChecklistApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.StaticFIChecklist); },
            declinejobCountVisible: FinalInspectionChecklistCount.staticFIChecklist.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.staticFIChecklist.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.staticFIChecklist.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.staticFIChecklist.approvedCount > 0 && FinalInspectionChecklistCount.staticFIChecklist.rejectedCount === 0,
            countVisible: false,
            listLength: FinalInspectionChecklistCount.staticFIChecklist.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorDynamicChecklist, {
            isViewOnly: isViewOnly,
            callApIStatus: staticFIChecklistApiCall,
            dynamicFIChecklistMaster: staticFIChecklist,
            paramKey: EFIChecklistKeys.StaticChecklist,
            parentComponent: EFIChecklistParent.StaticChecklist,
            jobCardId: id || "",
            showOnlyRejectedItems: true
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.DynamicChecklist && FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount > 0 ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 0px 8px 0px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setDynamicChecklistApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.DynamicChecklist); },
            declinejobCountVisible: FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.dynamicFIChecklist.approvedCount > 0 && FinalInspectionChecklistCount.dynamicFIChecklist.rejectedCount === 0,
            countVisible: false,
            listLength: FinalInspectionChecklistCount.dynamicFIChecklist.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorDynamicChecklist, {
            isViewOnly: isViewOnly,
            dynamicFIChecklistMaster: dynamicFIChecklist,
            callApIStatus: dynamicChecklistApiCall,
            paramKey: EFIChecklistKeys.DynamicChecklist,
            parentComponent: EFIChecklistParent.DynamicChecklist,
            jobCardId: id || "",
            showOnlyRejectedItems: true
        }))) : null;
    }) : (item === null || item === void 0 ? void 0 : item.Key) === EFinalInspectorModuleSection.FastnerChecklist && FinalInspectionChecklistCount.fastnerCheklist.rejectedCount > 0 ? item === null || item === void 0 ? void 0 : item.SectionAttributes.map(function (elem) {
        return !elem.HIDE ? /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12,
            padding: "16px 0px 8px 0px"
        }, /*#__PURE__*/ React.createElement(CustomeAccordianWithButton, {
            isMandatory: elem === null || elem === void 0 ? void 0 : elem.MANDATORY,
            title: item === null || item === void 0 ? void 0 : item.DisplayName,
            KeyForId: "FI_TASK_DETAILS_" + (item === null || item === void 0 ? void 0 : item.Key),
            switchButtonsEnabled: allswitchEnabled || (elem === null || elem === void 0 ? void 0 : elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue) || (elem === null || elem === void 0 ? void 0 : elem.DISABLED) && (elem === null || elem === void 0 ? void 0 : elem.DISABLEDDefaultValue),
            isDisabled: elem === null || elem === void 0 ? void 0 : elem.DISABLED,
            selected: (elem === null || elem === void 0 ? void 0 : elem.OPTIONALDefaultValue) || !(elem !== null && elem !== void 0 && elem.MANDATORY) && (elem === null || elem === void 0 ? void 0 : elem.MANDATORYDefaultValue),
            handleClick: function () { return setFastnerChecklistApiCall(true); },
            isAccordianOpen: item === null || item === void 0 ? void 0 : item.isAccordianOpen,
            handleAccordianClick: function (value) { return handleAccordianClick(value, EFinalInspectorModuleSection.FastnerChecklist); },
            declinejobCountVisible: FinalInspectionChecklistCount.fastnerCheklist.rejectedCount > 0,
            declineJobLength: FinalInspectionChecklistCount.fastnerCheklist.rejectedCount,
            highlightRejected: FinalInspectionChecklistCount.fastnerCheklist.rejectedCount > 0,
            highlightAccepted: FinalInspectionChecklistCount.fastnerCheklist.approvedCount > 0 && FinalInspectionChecklistCount.fastnerCheklist.rejectedCount === 0,
            countVisible: false,
            listLength: FinalInspectionChecklistCount.fastnerCheklist.totalCount
        }, /*#__PURE__*/ React.createElement(FinalInspectorDynamicChecklist, {
            isViewOnly: isViewOnly,
            dynamicFIChecklistMaster: fastenerChecklist,
            callApIStatus: fastnerChecklistApiCall,
            paramKey: EFIChecklistKeys.FastnerChecklist,
            parentComponent: EFIChecklistParent.FastnerChecklist,
            jobCardId: id || "",
            showOnlyRejectedItems: true
        }))) : null;
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null); }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(NoRowsOverlay, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, skeletonArray.map(function () { /*#__PURE__*/ return React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: '100vw',
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)); })))) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        sx: {
            paddingTop: Module === isModuleConfig.Bajaj ? "0px" : "42px"
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)))));
};
export default JobCardReworkTab;
